var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('NavBar'):_vm._e(),_c('div',{staticClass:"body"},[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }